import * as analytics from '@anm/analytic';
import Button from '@anm/components/buttons/Button';
import { noop } from 'lodash/fp';
import { useCallback, useEffect, useState, FC } from 'react';

import { ButtonLink, DowngradeButtons } from '../../Wrapper';
import CheckboxItem, { CheckboxItemClickProps } from '../CheckboxItem';

import Wrapper, { Container, TitleBlockWrapper } from './Wrapper';

export type ReasonStepProps = { onKeep: () => void; onCancel: () => void };

const missFeature = 'I am missing some essential features';
const anotherProduct = 'Switching to another product';
const expensive = 'It’s too expensive';
const noUse = 'I no longer use this product';

const ReasonStep: FC<ReasonStepProps> = ({ onKeep, onCancel }) => {
  const [reason, setReason] = useState<CheckboxItemClickProps>();
  const handleCancel = useCallback(() => {
    reason && analytics.trackCancelReason(reason.title, reason.description);
    onCancel();
  }, [reason, onCancel]);

  useEffect(() => {
    analytics.trackCancelAskForReason();
  }, []);

  return (
    <Wrapper>
      <TitleBlockWrapper
        direction="center"
        size="medium"
        title="Before you go - we value your feedback"
        description="What is the main reason for canceling?"
      />
      <Container>
        <CheckboxItem
          checked={reason?.title === missFeature}
          placeholder="Please share what we can improve"
          title={missFeature}
          onClick={setReason}
        />
        <CheckboxItem checked={reason?.title === anotherProduct} title={anotherProduct} onClick={setReason} />
        <CheckboxItem checked={reason?.title === expensive} title={expensive} onClick={setReason} />
        <CheckboxItem checked={reason?.title === noUse} title={noUse} onClick={setReason} />
      </Container>

      <DowngradeButtons>
        <Button size="big" variant="light-blue" onClick={onKeep}>
          Keep my plan
        </Button>
        <ButtonLink active={!!reason} size="big" variant="blue-link" onClick={!!reason ? handleCancel : noop}>
          Continue to cancellation
        </ButtonLink>
      </DowngradeButtons>
    </Wrapper>
  );
};

export default ReasonStep;
